import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {HOTB} from "../../HOTB";
import {TimelineLite, TimelineMax} from "gsap";
import {GameUtils} from "../../utils/GameUtils";
import {GameConfig} from "../../GameConfig";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../../core/reel/IReelData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {GameSounds} from "../../sound/GameSounds";

export class NormalResultPresentation implements FlowStatePresentation {
    private _tl: TimelineMax | undefined;
    private _stoppedReels: boolean[];

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        this._stoppedReels = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => false);

        this._tl = new TimelineMax();

        const stopDelay: number = GameUtils.isFastSpin() ? GameConfig.reelAllInStopDelayFastSpin : GameConfig.reelAllInStopDelay;

        let stopTime: number = 0,
            delay: number = 0,
            scatterDelay: number = 0;

        this._tl.add((): void => {
            HOTB.topReel.onGameResult();
            HOTB.leftReel.onGameResult();
            HOTB.rightReel.onGameResult();
        });

        for (let i: number = 0; i < HOTB.model.gameData.reels.length; i++) {
            const reelData: string[] = HOTB.model.gameData.reels[i],
                reelStopAnimation: TimelineMax = new TimelineMax();

            reelStopAnimation.add(this.preventSkipOnLastReel(i, flowStateController));
            reelStopAnimation.add(HOTB.reelArea.mainReelModels[i].stop(reelData), delay);
            HOTB.reelArea.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data: SimpleReelModelEventData): void => {
                this.onReelStop(data, flowStateController);
            });
            this._tl.add(reelStopAnimation, stopTime);

            if (GameConfig.TOTAL_SCATTER_COUNT >= 2 && !HOTB.model.gameData.featureBuyName.includes(ExtendedGameMode.FREESPIN)) {
                scatterDelay += GameUtils.isFastSpin() ? GameConfig.scatterAnticipationDelayFastSpin * 0.8 : GameConfig.scatterAnticipationDelay;
            }
            delay += stopDelay + scatterDelay * 2;
        }

        const padding: number = HOTB.gameFlowController.calculatePaddingDuration(this._tl.totalDuration());

        if (padding > 0) {
            const minSpinTime: number = HOTB.apiPlugin.gameClientConfiguration.minimumSpinTime;

            let reducingFactor: number;

            if (minSpinTime >= 5000) {
                reducingFactor = 0.87;
            } else if (minSpinTime >= 3000) {
                reducingFactor = 0.74;
            } else if (minSpinTime >= 2500) {
                reducingFactor = 0.65;
            } else {
                reducingFactor = 1;
            }

            this._tl.shiftChildren(((HOTB.apiPlugin.gameClientConfiguration.minimumSpinTime / 1000) - this._tl.totalDuration()) * reducingFactor);
        }
    }

    private preventSkipOnLastReel(reelId: number, flowStateController: FlowStateController): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (reelId === 4) {
            tl.add((): void => {
                flowStateController.setSkipCallback();
            }); //prevents useless skips when last reel has started its stop anyway.
        }
        return tl;
    }

    private onReelStop(data: SimpleReelModelEventData, flowStateController: FlowStateController): void {
        this._stoppedReels[data.reel] = true;
        if (GameUtils.isAllTrue(this._stoppedReels)) {
            if (GameUtils.isSatanSpin() && HOTB.model.gameData.nextMode !== ExtendedGameMode.NORMAL_AVALANCHE) {
                HOTB.soundPlayer.stopLoopEffect(HOTB.soundPlayer.satanSpinSoundPlaying);
                HOTB.soundPlayer.playSound(GameSounds.SATAN_SPIN_END);
                HOTB.soundPlayer.satanSpinSoundPlaying = "";
                if (HOTB.model.data.nextMode !== ExtendedGameMode.CAPWIN_GAME) {
                    HOTB.soundPlayer.fadeMusic(1, 0.01);
                }
            }

            this.completePresentation(flowStateController);
        }
    }

    private completePresentation(flowStateController: FlowStateController): void {
        flowStateController.finish();
        delete this._tl;
    }
}